import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

/**
 * Public layout — wraps all public pages with Navbar and Footer.
 * Hides Navbar and Footer on auth pages.
 */
const PublicLayout = () => {
  const location = useLocation();
  const isAuthPage = ['/login', '/signup'].includes(location.pathname);

  return (
    <>
      {!isAuthPage && <Navbar />}
      <main>
        <Outlet />
      </main>
      {!isAuthPage && <Footer />}
    </>
  );
};

export default PublicLayout;
